
import { apiDistributionDistributionLists } from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import { im } from "mathjs";
import addDistribution from "@/components/shop/distribution/add_distribution.vue";
import setLeader from "@/components/shop/distribution/set_leader.vue";
import setMerchant from "@/components/shop/distribution/set_merchant.vue";
@Component({
    components: {
        lsPagination,
        setLeader,
        addDistribution,
        setMerchant
    },
})
export default class ShopList extends Vue {
    /** S Data **/
    $refs!: { addDistributionRef: any, setLeaderRef: any, setMerchantRef: any };
    apiDistributionDistributionLists = apiDistributionDistributionLists;

    pager: RequestPaging = new RequestPaging();

    searchObj = {
        name: "",
        account: "",
        sn: ""
    };

    /** E Data **/
    /** S Methods **/

    handleMerchant(row:any) {
        this.$refs.setMerchantRef.open(row.id);
    }

    handleSetLeader(row:any) {
        this.$refs.setLeaderRef.open(row.id,row.first_leader);
    }

    handleAdd() {
        this.$refs.addDistributionRef.open(null);
    }

    // 编辑分销商
    handleEdit(row: any): void {
        this.$refs.addDistributionRef.open(row.id);
    }

    // 获取分销商列表
    getShopLists(): void {
        this.pager.request({
            callback: apiDistributionDistributionLists,
            params: {
                ...this.searchObj,
            },
        });
    }

    // 重置搜索
    reset(): void {
        Object.keys(this.searchObj).map((key) => {
            this.$set(this.searchObj, key, "");
        });
        this.getShopLists();
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getShopLists();
    }
}
